import ProcessingActivity, { ProcessingActivityState } from 'models/processingActivity';
import { FilterProcessingActivityGroupKeys } from './FilterProcessingActivityGroupKeys';
import Task from 'models/tasks/task';

const applyMultipleSharedfilter = (sharedFilters: string[], processingActivity: ProcessingActivity): boolean => {
  if (sharedFilters.length === 0) return true;

  let userCheck: boolean = false;
  if (sharedFilters.includes('everyone')) {
    userCheck = !processingActivity.authSchemaId;
  } else {
    userCheck = processingActivity.authSchemaId ? sharedFilters.includes(processingActivity.authSchemaId.toString()) : false;
  }

  return userCheck;
};

const taskStatusFilter = (statusFilters: string[], task?: Task): boolean => {
  if (statusFilters.length === 0) return true;
  if (!task) return false;
  if (statusFilters.includes('open')) {
    return !task.completed || statusFilters.includes(task.taskStateId.toString());
  } else {
    return statusFilters.includes(task.taskStateId.toString());
  }
};

export const filterProcessingActivities = (processingActivities: ProcessingActivity[], filter: string[]): ProcessingActivity[] => {
  const filteredList: ProcessingActivity[] = [];
  const stateFilterList: string[] = [];
  const ownerFilterList: string[] = [];
  const tagFilterList: string[] = [];
  const roleFilterList: string[] = [];
  const sharedFilterList: string[] = [];
  const dataFilterList: string[] = [];
  const classificationFilterList: string[] = [];
  const dataSubjectScaleFilterList: string[] = [];
  const checklistStatusFilterList: string[] = [];
  const transfersFilterList: string[] = [];


  filter.forEach((filter: string) => {
    const filterGroup = filter.split('$');
    const filterType = filterGroup[0] + '$';
    const filterValue = filterGroup[1];

    switch (filterType) {
      case FilterProcessingActivityGroupKeys.status:
        const idx0 = Number.parseInt(filterValue);
        if (idx0 >= 0) {
          stateFilterList.push(filterValue);
        }
        break;
      case FilterProcessingActivityGroupKeys.role:
        const idx1 = Number.parseInt(filterValue);
        if (idx1 >= 0) {
          roleFilterList.push(filterValue);
        }
        break;
      case FilterProcessingActivityGroupKeys.owner:
        ownerFilterList.push(filterValue);
        break;
      case FilterProcessingActivityGroupKeys.tag:
        tagFilterList.push(filterValue);
        break;
      case FilterProcessingActivityGroupKeys.shared:
        sharedFilterList.push(filterValue);
        break;
      case FilterProcessingActivityGroupKeys.dataAsset:
        dataFilterList.push(filterValue);
        break;
      case FilterProcessingActivityGroupKeys.classification:
        classificationFilterList.push(filterValue);
        break;
      case FilterProcessingActivityGroupKeys.dataSubjectScale:
        dataSubjectScaleFilterList.push(filterValue);
        break;
      case FilterProcessingActivityGroupKeys.taskStatus:
        checklistStatusFilterList.push(filterValue);
        break;
      case FilterProcessingActivityGroupKeys.transfers:
        transfersFilterList.push(filterValue);
        break;
      default:
        break;
    }
  });

  processingActivities.forEach((item: ProcessingActivity) => {
    let statusFilterCheck = true;
    let ownerFilterCheck = true;
    let tagFilterCheck = true;
    let roleFilterCheck = true;
    let sharedFilterCheck = true;
    let dataFilterCheck = true;
    let classificationFilterCheck = true;
    let dataSubjectScaleFilterCheck = true;
    let checklistStatusFilterCheck = true;
    let transfersFilterCheck = true;

    if (sharedFilterList.length > 0 && !applyMultipleSharedfilter(sharedFilterList, item)) {
      sharedFilterCheck = false;
    }

    if (
      ownerFilterList.length > 0 &&
      !(item.ownerId && ownerFilterList.includes(item.ownerId)) &&
      !(item.ownerRoleId && ownerFilterList.includes(item.ownerRoleId))
    ) {
      ownerFilterCheck = false;
    }

    if (roleFilterList.length > 0 && !roleFilterList.includes(item.role.toString())) {
      roleFilterCheck = false;
    }

    if (item.state === ProcessingActivityState.Archived) {
      statusFilterCheck = stateFilterList.includes(ProcessingActivityState.Archived.toString());
    } else if (stateFilterList.length > 0 && !stateFilterList.includes(item.state.toString())) {
      statusFilterCheck = false;
    }

    if (tagFilterList.length > 0 && !tagFilterList.some((t) => item.tagIds?.some((id) => id.toString() === t))) {
      tagFilterCheck = false;
    }
    if (dataFilterList.length > 0 && !dataFilterList.some((d) => item.data?.some((asset) => asset.assetId.toString() === d))) {
      dataFilterCheck = false;
    }

    if (classificationFilterList.length > 0 && !classificationFilterList.some((c) => item.getDataClassifications().some((cl) => cl.classificationId.toString() === c))) {
      classificationFilterCheck = false;
    }

    if (dataSubjectScaleFilterList.length > 0 && !dataSubjectScaleFilterList.includes(item.dataSubjectScale?.stringValueId.toString() || '')) {
      dataSubjectScaleFilterCheck = false;
    }

    if (checklistStatusFilterList.length > 0 && !taskStatusFilter(checklistStatusFilterList, item.dpiaTask)) {
      checklistStatusFilterCheck = false;
    }

    if (transfersFilterList.length > 0 && !transfersFilterList.includes(item.getDataZoneKey().toString())) {
      transfersFilterCheck = false;
    }

    if (
      roleFilterCheck &&
      statusFilterCheck &&
      ownerFilterCheck &&
      tagFilterCheck && 
      sharedFilterCheck &&
      dataFilterCheck &&
      classificationFilterCheck &&
      dataSubjectScaleFilterCheck &&
      checklistStatusFilterCheck &&
      transfersFilterCheck
    ) {
      filteredList.push(item);
    }
  });

  return filteredList;
};